import { useEffect } from "react";

// Component Imports
import { AlertMessage } from "@/components";
import { Loading } from "@/layout";

// Package Imports
import { SvgIcon } from "@mui/material";

// SVG/Icon Imports
import LogoSVG from "@/svgs/pulse_prime_logo.svg?react";

// Hook Imports
import { useAlerts, useOktaCallbackHandler } from "@/hooks";

const OktaCallback = () => {
  const { alerts, closeAlertMessage, showSuccess, showError } = useAlerts();
  const { status, handleOktaCallback } = useOktaCallbackHandler({
    onSuccess: () => {
      showSuccess("Okta sign-in completed.");
    },
    onError: (message) => {
      showError(message);
    },
  });

  // Kick off the Okta → Pulse exchange
  useEffect(() => {
    handleOktaCallback();
  }, [handleOktaCallback]);

  const showLoading = status === "handling";

  return (
    <div
      className="pulse-sidenav-adjusted-container pulse-bg-color--background-800"
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      {alerts.map((alert) => (
        <AlertMessage
          key={alert.id}
          id={alert.id}
          message={alert.message}
          status={alert.status}
          closeAlertMessage={closeAlertMessage}
        />
      ))}

      {showLoading && (
        <Loading />
      )}

      <SvgIcon
        sx={{
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
        }}
        children={<LogoSVG className="pulse-color--background-900" />}
      />
    </div>
  );
};

export default OktaCallback;
